import React from "react";

const WidgetCardSkeleton = () => (
  <div className="widgetCardSkeleton">
    <span className="linear-background widgetSkeletonValue" />
    <span className="linear-background widgetSkeletonTrend" />
    <span className="linear-background widgetSkeletonChart" />
  </div>
);

export default WidgetCardSkeleton;
